export default "__VITE_ASSET__Bx9t28Q5__"